/**
 * Project application setup
 *
 * Everything included in this file will output in the distribution build
 */
import 'core-js/shim';

// Lightbox
import 'lightbox2';

import 'slick-carousel';
import 'src/sass/style.scss';

import './app/index.js';



// WEBPACK FOOTER //
// ./src/index.js